class ProductCardSwatches extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.renderRedtabMemberShipPrice =  document.documentElement.getAttribute('data-renderRedtabMemberShipPrice')? JSON.parse(document.documentElement.getAttribute('data-renderRedtabMemberShipPrice')): null;
    }

    connectedCallback() {
        const dataScript = this.querySelector("script[type='application/json']");
        if (!dataScript) return;

        let productData = {};
        try {
            const jsonText = dataScript.textContent.trim();
            productData = JSON.parse(jsonText);
        } catch (err) {
            console.error("ProductCardSwatches: Invalid JSON", err);
            return;
        }
        
        const productId = productData.id;
        let currentSwatch = productData.variants[0].swatch_image_variant;
        const currentFallbackColor = productData.options.find(option => option.name?.toLowerCase() === 'color')?.values?.[0] || null;
        if (currentSwatch.includes('no-image')) {
            currentSwatch = null;
        }
        const bundleSwatches =
            productData.metafields?.bundleProducts && Array.isArray(productData.metafields.bundleProducts)
                ? productData.metafields.bundleProducts
                : [];

        // Filter out current swatch
        const swatchesToRender = bundleSwatches.filter(
                (s) => s.id !== JSON.parse(productData.id)
            );

        this.maxVisible = parseInt(this.getAttribute("data-limit"), 10) || 5;
        const remainingCount =
            swatchesToRender.length > this.maxVisible
                ? swatchesToRender.length - this.maxVisible
                : 0;

        const defaultData = {
            id: productData.id || "",
            handle: productData.handle || "",
            title: productData.title || "",
            featured_image: productData.featured_image || "",
            currentFallbackColor: currentFallbackColor,
            price: Number(productData.price) || 0,
            compare_at_price: Number(productData.compare_at_price) || 0,
            first_variant: productData.first_available_variant || "",
            swatch_image: currentSwatch,
            old_mrp: Number(productData.metafields?.metafieldPrice || 0),
            saleCount: Number(productData.metafields?.saleCount),
            tags: productData.tags
        };

        this._renderSwatches(swatchesToRender, defaultData, productId, remainingCount);

        // ✅ Update card once for default swatch display
        this._updateProductCard(defaultData, productId);
    }

    _renderSwatches(swatches, defaultData, productId, remainingCount) {
        const noImageUrl = "no-image";
        const liquidError = "Liquid error";
        let html = `<div class='swatch-container'>`;

        // Add current swatch (selected)
        html += `
      <div class='swatch selected' data-swatch-index='-1'>
        ${defaultData.swatch_image ? `<img src='${defaultData.swatch_image}' alt='current swatch' loading='lazy'>`: defaultData.currentFallbackColor ? `<div style='background-color:${defaultData.currentFallbackColor};'></div>` : `<div style='background-color:#ccc;'></div>`}
      </div>
    `;

        // Visible swatches
        html += swatches
            .slice(0, this.maxVisible)
            .map((swatch, index) => {
                const hasValidImage = swatch.swatch_image && !swatch.swatch_image.includes(noImageUrl) && !swatch.swatch_image.includes(liquidError);
   
                let color = null;
                try {
                    color = swatch.swatch_color
                        ? JSON.parse(swatch.swatch_color)
                        : null;
                } catch {
                    color = swatch.swatch_color || null;
                }
                let fallbackColorName = swatch.options?.[0]?.values?.[0] || "#ccc";
                if (fallbackColorName){
                    fallbackColorName = fallbackColorName?.replace(/\s+/g, '').replace(/dark/gi, '').toLowerCase();
                }
                if (hasValidImage) {
                    return `<div class='swatch' data-image data-swatch-index='${index}'><img src='${swatch.swatch_image}' alt='${swatch.title || ""}' loading='lazy'></div>`;
                } else if (color) {
                    return `<div class='swatch' data-color data-swatch-index='${index}'><div style='background-color:${color};'></div></div>`;
                } else if (fallbackColorName) {
                    return `<div class='swatch' data-fallback-color data-swatch-index='${index}'><div style='background-color:${fallbackColorName};'></div></div>`;
                } else {
                    return `<div class='swatch' data-default data-swatch-index='${index}'><div style='background-color:#ccc;'></div></div>`;
                }
            })
            .join("");

        // +N Button
        if (remainingCount > 0) {
            html += `<div class='swatch more' id='showMore'>+${remainingCount}</div>`;
        }

        html += `</div>`;

        const style = `
      <style>
        .swatch-container { display:flex; flex-wrap:wrap; gap:0.5rem 0.8rem; padding-bottom:1rem; }
        .swatch { display:flex; justify-content:center; align-items:center; width:20px; height:20px; border-radius:50%; overflow:hidden; cursor:pointer; flex-shrink:0; padding: 1px; }
        .swatch img, .swatch div { width:98%; height:99%; border-radius:50%; object-fit:cover; aspect-ratio: 1;}
        .swatch div { border:1px solid grey; }
        .selected { border:1px solid black; }
        .more { display:flex; align-items:center; justify-content:center; font-size:12px; color:black; border-radius:50%; border: 1px solid grey; width:20px; height:20px; cursor:pointer; }
        .swatch.more{border:none;}
        @media (max-width:767px){
          .swatch{flex:0 0 auto; width:18px; height:18px; padding:2px;}
        }
      </style>
    `;

        this.shadowRoot.innerHTML = style + html;
        this._bindEvents(swatches, defaultData, productId);
    }

    _bindEvents(swatches, defaultData, productId) {
        const shadow = this.shadowRoot;
        const moreBtn = shadow.getElementById("showMore");
        const allSwatches = shadow.querySelectorAll(".swatch");

        // ✅ Expand all swatches when +N clicked
        if (moreBtn) {
            moreBtn.addEventListener("click", () => {
                const allCount = swatches.length;
                this.maxVisible = allCount;
                this._renderSwatches(swatches, defaultData, productId, 0);
            });
        }

        allSwatches.forEach((el) => {
            el.addEventListener("click", () => {
                allSwatches.forEach((s) => s.classList.remove("selected"));
                el.classList.add("selected");

                const idx = parseInt(el.dataset.swatchIndex, 10);
                const selectedData =
                    idx === -1 ? defaultData : swatches[idx] || defaultData;

                this._updateProductCard(selectedData, productId);

                
                if (el && !Number.isNaN(idx) && productId){
                    const swatchIndex = idx + 2;
                    window.dispatchEvent(new CustomEvent("product-card:swatch-selected", {
                        bubbles: true,
                        detail: {
                            data: {
                                colorGroupingIndex :swatchIndex,
                                productId
                            }
                        }
                    }))
                }
            });
        });
    }

    _updateProductCard(selectedData, productId) {
        const card = this.closest(
            `.product-card[data-product-id='${productId}']`
        );
        if (!card) return;
        const img = card.querySelector(".product-card-image img");
        const anchor = card.querySelector(".product-card-image");
        const titleElem = card.querySelector(".product-card__title");
        const priceElem = card.querySelector(".product-card__price-sale");
        const compareElem = card.querySelector(".product-card__price-compare");
        const offElem = card.querySelector(".product-card--discount");
        const oldMprParent = card.querySelector(".mmc-card-members-price");
        const oldMpr = card.querySelector(".mmc-card-members-price .mmc-price-sale");
        const membershipPriceWrapper = card.querySelector(".mmc-card-membership-price__wrapper");
        const membershipPriceEl = membershipPriceWrapper?.querySelector(".mmc-card-membership-price");
        const wishlistBtn = card.querySelector(".wishlist-btn");
        const soldUnitsEl = card.querySelector(".product-card__sold-units-count");
        const isRedtabMembershipEligibleProduct = selectedData.tags.includes("red tab bonus") || selectedData.tags.includes("Red Tab Bonus");

        // ✅ Update product image & link
        if (img && selectedData.featured_image) {
            img.src = selectedData.featured_image;
            img.srcset = selectedData.featured_image;
        }
        if (anchor && selectedData.handle)
            anchor.href = `/products/${selectedData.handle}`;

        // ✅ Update title
        if (titleElem && selectedData.title)
            titleElem.textContent = selectedData.title;
            titleElem.href = `/products/${selectedData.handle}`;
        // ✅ Update price and compare-at price
        if (priceElem)
            priceElem.textContent = this._formatMoney(selectedData.price);

        const price = Number(selectedData.price);
        const compareAt = Number(selectedData.compare_at_price);

        if (compareElem && offElem) {
            if (compareAt > price) {
                compareElem.style.display = "block";
                offElem.style.display = "block";
                compareElem.textContent = this._formatMoney(compareAt);
                const offPercentage = Math.floor((100 * (compareAt - price)) / compareAt);
                offElem.textContent = `${offPercentage}% OFF`;
            } else {
                compareElem.style.display = "none";
                offElem.style.display = "none";
            }
        }

        // ✅ Handle old MRP visibility
        if (oldMpr && selectedData.old_mrp > 0) {
            oldMprParent.style.display = "flex";
            oldMpr.textContent = this._formatMoney(selectedData.old_mrp);
        } else if (oldMprParent) {
            oldMprParent.style.display = "none";
        }
        // Handle rednering Redtab Membership
        if (this.renderRedtabMemberShipPrice){
            if (isRedtabMembershipEligibleProduct){
                const membershipDiscountedValue = price * 0.95
                const formattedmembershipDiscountedValue = this._formatMoney(membershipDiscountedValue);
                if (membershipPriceWrapper && membershipPriceEl){
                    membershipPriceWrapper.style.display = "flex";
                    membershipPriceEl.textContent = formattedmembershipDiscountedValue;
                }else{
                    const membershipPriceMarkup = 
                        `<div class="mmc-card-membership-price__wrapper tw-gap-[2px] tw-pt-2 tw-flex tw-flex-wrap tw-items-baseline" style="display:flex !important;">
                            <span class="mmc-price-compare tw-font-secondary tw-text-[#c41320] tw-text-[12px] tw-leading-none">Member Price: </span>
                            <span class="mmc-card-membership-price tw-font-secondary tw-text-[12px] tw-text-[#c41320] tw-leading-none">${formattedmembershipDiscountedValue}</span>
                        </div>`
                    priceElem.parentElement.insertAdjacentHTML('afterend', membershipPriceMarkup);
                }
            }else{
                if (membershipPriceWrapper && membershipPriceEl){
                    membershipPriceWrapper.style.display = "none";
                }
            }
        }


        // ✅ Update wishlist attributes
        if (wishlistBtn) {
            wishlistBtn.setAttribute("data-proid", selectedData.id);
            wishlistBtn.setAttribute(
                "data-varid",
                selectedData.first_variant || ""
            );
            wishlistBtn.setAttribute("data-added", false);
        }

        if (typeof allHulkWishlistButtons !== "undefined") {
            allHulkWishlistButtons = Array.from(document.querySelectorAll('[data-wishlist]'));
            HulkappWishlist._checkForProductStatus(allHulkWishlistButtons, 'multiple');
        }

        if (selectedData.saleCount >= 1000 ){
            const soldUnitsCountText = `${selectedData.saleCount}` 
            if (soldUnitsEl){
                soldUnitsEl.textContent = soldUnitsCountText;
                if (soldUnitsEl.parentElement.classList.contains("tw-hidden")){
                    soldUnitsEl.parentElement.classList.remove("tw-hidden");
                }
            }else{
                const soldUnitsEl = `<p class="product-card__sold-units tw-font-medium" style="font-size: 10px; color: #6e6e6e;">
                <span class="product-card__sold-units-count tw-text-[#C41320]">${soldUnitsCountText}</span> Units Sold
                </p>`
                titleElem?.insertAdjacentHTML("beforebegin", soldUnitsEl);
            }
        }else{
            if (soldUnitsEl){
                soldUnitsEl.textContent = "";
                soldUnitsEl.parentElement.classList.add("tw-hidden");
            }
        }
    }

    _formatMoney(value) {
        const n = Number(value) / 100;
        try {
            return new Intl.NumberFormat("en-IN", {
                style: "currency",
                currency: "INR",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(n);
        } catch {
            return `₹${Math.round(n)}`;
        }
    }
}

if (!customElements.get("product-card-swatches")) {
    customElements.define("product-card-swatches", ProductCardSwatches);
}
